import React from 'react'

import Select from '@ui-kit/components/formComponents/Select/index.web'
import type { Option, OptionValue } from '@ui-kit/components/formComponents/Select/types'

import type { Status } from './hooks'

type Props = {
  name: string
  label: string
  status?: Status
  options?: Option[]
  styleType: 'underlined' | 'outlined'
  onChangeFilterInputValue?: (filter: string) => void | Promise<void>
  onValueChange: (value: OptionValue | null) => void
  errorMessage?: string
}

const Autocomplete = (props: Props) => {
  const optionsStatus = props.status?.name === 'success' ? props.status?.predictions : []
  return (
    <Select
      errorMessage={props.errorMessage}
      name={props.name}
      styleType={props.styleType}
      label={props.label}
      options={props.options || optionsStatus}
      onChangeFilterInputValue={props.onChangeFilterInputValue}
      onValueChange={props.onValueChange}
      useFilterInput
      hideIcon
      status={props.status?.name === 'error' ? 'error' : undefined}
    />
  )
}

export default Autocomplete
